<script setup lang="ts">
defineProps<{ title: string }>();
const { params, blog, isLoading, status, error } = useBlog();
async function onUpdatePage() {
  await nextTick();
  document.getElementById("blog")?.scrollIntoView({ behavior: "smooth" });
}
</script>

<template>
  <div id="blog" class="container flex flex-col gap-8 py-16">
    <h1 class="h1 text-primary">
      {{ title }}
    </h1>
    <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
      <BlogPostList :posts="blog.posts" />
    </UiQueryWrapper>
    <UiPagination v-model:page="params.page" :items-per-page="params.per_page" :total="blog.posts_total" @update:page="onUpdatePage" />
  </div>
</template>
